import { render, staticRenderFns } from "./ScottNotesMaterial.vue?vue&type=template&id=c6a74a0a"
import script from "./ScottNotesMaterial.vue?vue&type=script&lang=js"
export * from "./ScottNotesMaterial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports